import { Tooltip } from "PFComponents/tooltip";
import { AvailabilityRange } from "PFCore/types";
import { useTranslation } from "react-i18next";

import { ActionIcon } from "../../action_icon";
import { Typography } from "../../typography";
import css from "./rules_carousel_toolbar.module.scss";

type RulesCarouselToolbarProps = {
  onNext: () => void;
  onPrev: () => void;
  onCreate: () => void;
  onRemove: (index: number) => void;
  carouselIndex: number;
  rules: AvailabilityRange[];
  isDisabled?: boolean;
  hasErrors?: boolean;
  isValidating?: boolean;
};

export const RulesCarouselToolbar = ({
  onNext,
  onPrev,
  onCreate,
  onRemove,
  carouselIndex,
  rules,
  isDisabled,
  hasErrors,
  isValidating
}: RulesCarouselToolbarProps) => {
  const { t } = useTranslation();

  const hasMissingDate = rules.length > 0 && rules.some(({ start, end }) => !start || !end);

  return (
    <div className={css.carouselNavigation}>
      <ActionIcon
        name="chevron-left"
        size="sm"
        onClick={onPrev}
        disabled={carouselIndex === 0 || rules.length <= 1}
      />
      <span className={css.title}>
        <Typography variant="bodyRegular" tag="span">
          {t("availabilityRequirement.ruleXofY", {
            index: carouselIndex + 1,
            total: rules.length
          })}
        </Typography>
        <Tooltip
          disabled={!isValidating && !hasErrors}
          content={t("availabilityRequirement.tooltips.fixExistingRulesBeforeAddingNewOne")}
        >
          <ActionIcon
            name="add"
            size="sm"
            onClick={onCreate}
            disabled={isValidating || hasErrors || hasMissingDate || isDisabled}
          />
        </Tooltip>
        <ActionIcon
          name="remove"
          size="sm"
          color="paletteRed0"
          onClick={() => onRemove(carouselIndex)}
          disabled={rules.length === 0 || isDisabled}
        />
      </span>
      <ActionIcon
        name="chevron-right"
        size="sm"
        onClick={onNext}
        disabled={carouselIndex === rules.length - 1 || rules.length <= 1}
      />
    </div>
  );
};
